import React from 'react'
import styled from 'styled-components'

import { HighlightedText, pluralize, DeletingIn } from '@sketch/components'

import {
  ImageWrapper,
  GridWrapper,
  Name,
  DropdownButtonWrapper,
  SelectedCheckboxFloatingWrapper,
  SelectedCheckbox,
  IconsWrapper,
} from '../DocumentItem/DocumentItem.styles'
import {
  StyledSubtitleTextWrapper,
  StyledFolderIcon,
  SelectedShadowWrapper,
  SelectedShadow,
} from './ProjectItem.styles'
import {
  ProjectItemProps,
  getButtonProps,
  renderDropdown,
  renderPreview,
} from './utils'
import { useSearch } from '@sketch/utils'
import { useFlag } from '@sketch/modules-common'

export const ProjectItemGridView = styled(function ProjectItemGridView(
  props: ProjectItemProps
) {
  const {
    archivedAt,
    className,
    name,
    identifier,
    childrenItemCount = 0,
    childrenItemLabel = pluralize('Document', 'Documents', childrenItemCount),
    deletedAt,
    renderDropdownItems,
    onClick,
    selected,
    showSelectionCheckbox,
    onSelectChange,
  } = props

  const isMultipleSelectionOn = useFlag('multiple-selection')

  const previewImage = renderPreview(props, 'grid')
  const a11yProps = onClick ? getButtonProps(onClick) : {}
  const { search } = useSearch()

  return (
    <GridWrapper
      className={className}
      title={name}
      data-testid="project-item"
      {...a11yProps}
    >
      <IconsWrapper
        data-project-id={identifier}
        $isSelected={selected}
        $showSelectionCheckbox={showSelectionCheckbox}
      >
        <ImageWrapper data-project-id={identifier}>
          {previewImage}

          {isMultipleSelectionOn && (
            <SelectedCheckboxFloatingWrapper
              onClick={event => event.stopPropagation()}
            >
              <span className="sr-only">
                {selected ? 'Unselect document' : 'Select document'}
              </span>
              <SelectedCheckbox
                type="checkbox"
                checked={selected}
                onChange={event => onSelectChange?.(event.target.checked)}
              />
            </SelectedCheckboxFloatingWrapper>
          )}
        </ImageWrapper>

        {selected && (
          <SelectedShadowWrapper>
            <SelectedShadow />
          </SelectedShadowWrapper>
        )}
      </IconsWrapper>

      <Name>
        <StyledFolderIcon aria-label="Folder Icon" />
        <HighlightedText search={search}>{name}</HighlightedText>
      </Name>
      <StyledSubtitleTextWrapper>
        <b className="shrink">{`${childrenItemCount} ${childrenItemLabel}`}</b>

        {archivedAt && <div className="keep-size">Archived</div>}

        {deletedAt && (
          <div className="keep-size">
            <DeletingIn deletedAt={deletedAt} />
          </div>
        )}
      </StyledSubtitleTextWrapper>

      {renderDropdownItems && (
        <DropdownButtonWrapper>
          {renderDropdown(renderDropdownItems(), props.deletedAt)}
        </DropdownButtonWrapper>
      )}
    </GridWrapper>
  )
})``
